import { render, staticRenderFns } from "./DialogTemplate.vue?vue&type=template&id=5cc5197a&scoped=true&"
import script from "./DialogTemplate.vue?vue&type=script&lang=js&"
export * from "./DialogTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DialogTemplate.vue?vue&type=style&index=0&id=5cc5197a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc5197a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow,VSpacer})
